import { ButtonFormats, ButtonSizes, IconNames } from '@/components/UI/Types'
import Icon from '@/components/UI/icon/Icon'
import { ButtonHTMLAttributes } from 'react'
import styles from './IconButton.module.scss'
const IconSize = { large: 24, medium: 20, small: 12 }
interface IconButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconNames
  format: ButtonFormats
  size?: ButtonSizes
  disabled?: boolean
  loading?: boolean
  data_cy?: string
  className?: string
}
const IconButton = ({
  icon,
  format,
  size = 'medium',
  disabled,
  loading,
  data_cy,
  className = '',
  ...props
}: IconButton) => {
  return (
    <button
      {...props}
      disabled={disabled || loading}
      type="button"
      className={
        styles['icon-button-class'] +
        ' ' +
        styles[`${format}`] +
        ' ' +
        styles[`${size}`] +
        ' ' +
        `${loading ? styles['loading'] : ''}` +
        ' ' +
        className
      }
      data-cy={data_cy}
    >
      <Icon type={'inherit'} name={icon} size={IconSize[size]} />
    </button>
  )
}
export default IconButton
